export default __webpack_public_path__ + "static/media/11.3f4dd33a.jpg";